import React, { useEffect, useState } from "react";
import classNames from "classnames";
import CookieConsent from "react-cookie-consent";
import { Link } from "gatsby";

import { COOKIE_NAME } from "../../../utils/constants";
import * as Analytics from "../../../utils/analytics";

import styles from "./Consent.module.scss";
import { useAppContext } from "../../Context/AppContext";
import { Title } from "../Title";

const Consent: React.FC = () => {
  const { animating } = useAppContext();

  const [active, setActive] = useState(false);

  useEffect(() => {
    if (!animating && !active) {
      const timer = setTimeout(() => {
        setActive(true);
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [animating, active]);

  return (
    <CookieConsent
      onAccept={() => {
        Analytics.loadScripts();
      }}
      buttonText="Okay, no problem"
      cookieName={COOKIE_NAME}
      cookieValue={1}
      buttonClasses={styles.btn}
      declineButtonClasses={styles.decline}
      containerClasses={classNames(styles.container, {
        [styles.active]: active,
      })}
      contentClasses={styles.content}
      buttonWrapperClasses={styles.btnWrapper}
      declineButtonText="No thanks"
      disableStyles
      enableDeclineButton
    >
      <Title size="small" className={styles.title}>
        Our website uses cookies.
      </Title>
      <br />
      <p>
        We only use essential cookies and Google Analytics to collect anonymised
        information such as browser information, referrer information and to
        monitor site traffic. For more information, see the{" "}
        <a
          href="https://policies.google.com/privacy?hl=en-US"
          target="_blank"
          rel="noreferrer noopener"
        >
          Google Analytics privacy policy
        </a>
        .
      </p>
    </CookieConsent>
  );
};

export { Consent };
